import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

// Las dos keys valen: Supabase renombro "anon key" a "publishable key" y son
// el mismo formato `sb_publishable_...`. Se aceptan ambas porque el CI de
// GitLab (.gitlab-ci.yml) solo define REACT_APP_SUPABASE_ANON_KEY: si se
// aceptara unicamente la nueva, el build de produccion compila con undefined,
// createClient no tira, y el sitio entero queda sin auth y sin datos.
const supabaseKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error("[ERROR] Error: Supabase URL o Key no están definidos.");
}


export const supabase = createClient(supabaseUrl, supabaseKey);


